import React from 'react';
import { Layout, Menu, Typography } from 'antd';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import { UnorderedListOutlined, PrinterOutlined, LogoutOutlined } from '@ant-design/icons';
import Logo from '../Logo';
import Version from '../Version';
import { logout } from '../../utils/auth';

const { Content, Sider } = Layout;

const PrinterLayout = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const userStr = localStorage.getItem('user');
  const user = JSON.parse(userStr);

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  const menuItems = [
    {
      key: 'orders',
      icon: <UnorderedListOutlined />,
      label: '订单列表',
      onClick: () => navigate('/printer/orders')
    },
    {
      key: 'print',
      icon: <PrinterOutlined />,
      label: '订单打印',
      onClick: () => navigate('/printer/print')
    },
    {
      key: 'logout',
      icon: <LogoutOutlined />,
      label: '退出登录',
      onClick: handleLogout
    }
  ];

  // Get the current selected key from the path
  const selectedKey = location.pathname.split('/')[2] || 'orders';

  return (
    <Layout style={{ minHeight: '100vh', background: '#fff' }}>
      <Sider 
        width={200} 
        theme="light"
        style={{
          overflow: 'auto',
          height: '100vh',
          position: 'fixed',
          left: 0,
          top: 0,
          bottom: 0,
          display: 'flex',
          flexDirection: 'column'
        }}
      >
        <div style={{ height: '120px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <Logo />
        </div>
        <Version />
        <div style={{ marginLeft: '30px', marginBottom: '10px', textAlign: 'left' }}>
          <Typography.Text>欢迎您，{user?.username}</Typography.Text>
        </div>
        <Menu
          mode="inline"
          selectedKeys={[selectedKey]}
          style={{ flex: 1, borderRight: 0 }}
          items={menuItems}
        />
      </Sider>
      <Layout style={{ marginLeft: 200, background: '#fff', minHeight: '100vh' }}>
        <Content style={{ margin: '10px' }}>
          <div style={{ padding: '2px 10px', minHeight: 280 }}>
            <Outlet />
          </div>
        </Content>
      </Layout>
    </Layout>
  );
};

export default PrinterLayout;
